import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const NEED_IDENTIFICATION = 'PUBLISH_AVAILABLE :: NEED_IDENTIFICATION';

export type TNeedIdentificationAction = IReduxAction<typeof NEED_IDENTIFICATION, boolean>;

export const needIdentification = actionGenerator<typeof NEED_IDENTIFICATION, boolean>(NEED_IDENTIFICATION);
